var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":_vm.submitSurveyResponse}},[_vm._v("submit response")])])
}
var staticRenderFns = []

export { render, staticRenderFns }